import React from 'react'
import Page from 'contexts/page'
import SurveysProvider from 'contexts/surveys'
import Hero from './hero'
import CustomSurveysUpgradeCTA from 'pages/surveys/components/custom-surveys-upgrade-cta'
import Surveys from 'pages/surveys/lists/surveys'

const SurveysPane = ({ salt }) => (
    <>
        <Hero salt={salt} />
        <CustomSurveysUpgradeCTA salt={salt} />
        <Surveys />
    </>
)

export default ({ title, upgradable, ...props }) => (
    <Page
        view="surveys_all"
        title={title}
        upgrade={{
            enabled: upgradable,
            title: 'surveys',
            tutorial: {
                which: 'surveys',
                upgrade: { module: 'surveys' }
            }
        }}>
        <SurveysProvider>
            <SurveysPane {...props} />
        </SurveysProvider>
    </Page>
)